import React, { useEffect, useState } from "react";
import { ConsentResource } from "../../../resources";
import { Grid } from "@material-ui/core";
import ConsentForm from "../Consents/ConsentForm";
import { useCommonWidths } from "../../../hooks";
import { useOnboardingStyles } from "./styles";
import { OnboardingHeader } from "./OnboardingHeader";
import { CommonOnboardingProps } from "./Onboarding";
import { NavigationButtons } from "./NavigationButtons";

type ConsentsDataModel = {
	ecommunications: "true" | "false";
	emarketing: "true" | "false";
};

type ConsentsProps = CommonOnboardingProps & {
	consents: ConsentResource[];
};

export const OnboardingConsents = (props: ConsentsProps) => {
	const {
		consents,
		completeOnboardingPage,
		onboardingStateHandler,
		navigateBack,
		isLastStep,
	} = props;

	const classes = useOnboardingStyles();
	const isMobile = useCommonWidths().isSmDown;

	const [consentStates, setConsentStates] = useState<ConsentsDataModel>({
		ecommunications: onboardingStateHandler.state.consents.ecommunications,
		emarketing: onboardingStateHandler.state.consents.emarketing,
	});

	const handleConsentChange = (e: any, value: boolean) => {
		const consentId = e.target.id as keyof ConsentsDataModel;

		setConsentStates({ ...consentStates, [consentId]: value.toString() });
	};

	// Update `formStateHandler`'s Consent state from <Onboarding /> component whenever 'consentStates' changes
	useEffect(() => {
		onboardingStateHandler.update({
			...onboardingStateHandler.state,
			consents: {
				ecommunications: consentStates.ecommunications,
				emarketing: consentStates.emarketing,
			},
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [consentStates]); // [consentStates] should be the only dependency

	return (
		<Grid container spacing={3}>
			<OnboardingHeader
				isMobile={isMobile}
				subtitle="For at du skal kunne bruke Min Side, trenger vi at du samtykker til vårt vilkår om 'Digital Kommunikasjon'"
			/>
			<div className={classes.formWrapper}>
				<Grid container item xs={12} justify="center">
					<ConsentForm
						onChange={(e: any, val: boolean) => handleConsentChange(e, val)}
						consentsFromProps={consents} // Just to prevent fetches when rendering <ConsentForm />
						externalState={{
							ecommunications: consentStates.ecommunications,
							emarketing: consentStates.emarketing,
						}}
						renderDuringOnboarding={isMobile}
					/>

					<NavigationButtons
						handleNavigateNext={completeOnboardingPage}
						nextDisabled={!Boolean(consentStates.ecommunications === "true")}
						handleNavigatePrev={navigateBack}
						prevBtnHidden={false}
						isLastStep={isLastStep}
					/>
				</Grid>
			</div>
		</Grid>
	);
};
